import { render, staticRenderFns } from "./ChannelProviderForm.vue?vue&type=template&id=ca67cb90&scoped=true"
import script from "./ChannelProviderForm.vue?vue&type=script&lang=js"
export * from "./ChannelProviderForm.vue?vue&type=script&lang=js"
import style0 from "./ChannelProviderForm.vue?vue&type=style&index=0&id=ca67cb90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca67cb90",
  null
  
)

export default component.exports